import React, { useState } from "react";

import BuyNowCard from "./BuyNowCard";
import BidNowCard from "./BidNowCard";
import BidNowBuyNowCard from "./BidNowBuyNowCard";
import BidNowModal from "./BidNowModal";
import BuyNowModal from "./BuyNowModal";
import HighestBidder from "./HighestBidder";
import NotHighestBidder from "./NotHighestBidder";
import SoldVehicleCard from "../SoldVehicleCard";

interface BidNowBuyNowProps {
  onBuyNow: () => Promise<void>;
  onPlaceBid: () => Promise<void>;
  onAcceptTC: () => Promise<void>;
  getBiddingInfo: () => void;
  setBidAmount: (value: number) => void;
  setInfo: (value: any) => void;
  setIsTracked: (value: boolean) => void;
  vrm: string | string[];
  isTracked: boolean;
  reserveMet: boolean;
  buyNowPrice: number;
  bidAmount: number;
  currentBidAmount: number;
  myMaxProxy: number;
  startingBidAmount: number;
  increment: number;
  userBidStatus: string;
  saleEndDate: string;
  biddingViewType: string;
  buyNowResult: string | null;
  saleStatus: string;
  termsAndConditionsNeedAccepting: boolean | null;
  termsAndConditionsLink: string | null;
  bidHistory: {
    bidderName: string;
    placedByName: string;
    bidDateTime: string;
    bidAmount: number;
  }[];
  lotStatus: string;
  inventoryId: string | null;
  isToUseAuthZero?: boolean;
  accessToken?: string;
}

const BidNowBuyNow: React.FunctionComponent<BidNowBuyNowProps> = ({
  onBuyNow,
  onPlaceBid,
  setBidAmount,
  getBiddingInfo,
  onAcceptTC,
  vrm,
  isTracked,
  buyNowPrice,
  saleEndDate,
  reserveMet,
  bidAmount,
  currentBidAmount,
  biddingViewType,
  buyNowResult,
  increment,
  bidHistory,
  startingBidAmount,
  userBidStatus,
  myMaxProxy,
  saleStatus,
  termsAndConditionsNeedAccepting,
  termsAndConditionsLink,
  setInfo,
  setIsTracked,
  lotStatus,
  inventoryId,
  isToUseAuthZero,
  accessToken,
}) => {
  const [modal, setModal] = useState(null);

  const openBuyNowModal = () => setModal("buyNowModal");
  const openBidNowModal = () => setModal("bidNowModal");
  const closeModal = () => setModal(null);

  const nextPossibleBid =
    currentBidAmount > 0 ? currentBidAmount + increment : startingBidAmount;

  const bidResultReturned = !!buyNowResult;
  const displayBidOutcomes =
    !bidResultReturned &&
    (saleStatus === "PostSaleAdmin" || saleStatus === "Ended");
  const displayOutcomes = displayBidOutcomes || bidResultReturned;

  return (
    <>
      {!displayOutcomes &&
        biddingViewType === "BuyNowOnly" &&
        lotStatus !== "Sold" && (
          <BuyNowCard buyNowAmount={buyNowPrice} onBuy={openBuyNowModal} />
        )}
      {!displayOutcomes &&
        biddingViewType === "BidNowOnly" &&
        lotStatus !== "Sold" && (
          <BidNowCard
            bidAmount={bidAmount}
            reserveMet={reserveMet}
            currentBid={currentBidAmount}
            openBidNowModal={openBidNowModal}
            setBidAmount={setBidAmount}
            increment={increment}
            bidHistory={bidHistory}
            startingBidAmount={startingBidAmount}
            userBidStatus={userBidStatus}
            myMaxProxy={myMaxProxy}
            nextPossibleBid={nextPossibleBid}
            getBiddingInfo={getBiddingInfo}
            setInfo={setInfo}
          />
        )}
      {!displayOutcomes &&
        biddingViewType === "BidNowBuyNow" &&
        lotStatus !== "Sold" && (
          <BidNowBuyNowCard
            buyNowAmount={buyNowPrice}
            currentBid={currentBidAmount}
            bidAmount={bidAmount}
            reserveMet={reserveMet}
            increment={increment}
            bidHistory={bidHistory}
            startingBidAmount={startingBidAmount}
            userBidStatus={userBidStatus}
            myMaxProxy={myMaxProxy}
            nextPossibleBid={nextPossibleBid}
            setBidAmount={setBidAmount}
            openBuyNowModal={openBuyNowModal}
            openBidNowModal={openBidNowModal}
            getBiddingInfo={getBiddingInfo}
            setInfo={setInfo}
          />
        )}
      {bidResultReturned && buyNowResult !== "Success" && (
        <SoldVehicleCard
          heading="Unfortunately, you missed out"
          headingColor="primary-red"
        />
      )}
      {displayBidOutcomes && userBidStatus === "WithYou" && (
        <HighestBidder bidAmount={bidAmount} reserveMet={reserveMet} />
      )}
      {displayBidOutcomes && userBidStatus !== "WithYou" && (
        <NotHighestBidder
          bidAmount={bidAmount}
          reserveMet={reserveMet}
          userBidStatus={userBidStatus}
          myMaxProxy={myMaxProxy}
          bidHistory={bidHistory}
        />
      )}
      {modal === "buyNowModal" && (
        <BuyNowModal
          buyNowAmount={buyNowPrice}
          saleEndDate={saleEndDate}
          isOpen={modal === "buyNowModal"}
          onClose={closeModal}
          onBuyNow={onBuyNow}
          onAcceptTC={onAcceptTC}
          termsAndConditionsLink={termsAndConditionsLink}
          termsAndConditionsNeedAccepting={termsAndConditionsNeedAccepting}
        />
      )}
      {modal === "bidNowModal" && (
        <BidNowModal
          reserveMet={reserveMet}
          bidAmount={bidAmount}
          currentBid={currentBidAmount}
          saleEndDate={saleEndDate}
          isOpen={modal === "bidNowModal"}
          onClose={closeModal}
          onPlaceBid={onPlaceBid}
          onAcceptTC={onAcceptTC}
          termsAndConditionsLink={termsAndConditionsLink}
          termsAndConditionsNeedAccepting={termsAndConditionsNeedAccepting}
          isTracked={isTracked}
          vrm={vrm}
          setIsTracked={setIsTracked}
          inventoryId={inventoryId}
          isToUseAuthZero={isToUseAuthZero}
          accessToken={accessToken}
        />
      )}
    </>
  );
};

export default BidNowBuyNow;
